module.exports = __webpack_public_path__ + "aaa93897b471b8c81e66fc900774bf24.png";